import { createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../constants/apiRoutes";
import { authApi } from "../../../constants/reduxConstant";
import { getAuthorization } from "../../../services/config";
import { updateLoading } from "../loader";
import { ToastNotifyError } from "../../../components/CommonComponents/Toast/ToastNotify";

const { login = "", logout = "", guest_user_flow = "", terms_and_condition= "" } = authApi;
const { V1: { LOGIN, LOGOUT, SIGNUP, SOCIAL_LOGIN,RESET_PASSWORD, GET_GUEST_USER_FLOW, TERMS_AND_CONDITION, PRIVACY_POLICY, FORGET_PASSWORD, RESET_LINK_CHECK } = {} } = API_ROUTES;

const fetchLogin = createAsyncThunk(
  login,
  async (payload, { dispatch, getState }) => {
    const API = getAuthorization(getState, {isAuthHeader: true, isSessionKey: true});
    try {
      dispatch(updateLoading(true));
      const response = await API.post(LOGIN, payload);
      dispatch(updateLoading(false));
      return response;
    } catch (err) {
      ToastNotifyError(err);
      return err;
    }
  }
);

const fetchLogout = createAsyncThunk(
  logout,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, {isAuthHeader: true});
    try {
      dispatch(updateLoading(true));
      const response = await API.post(LOGOUT, data);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchPostSignup = createAsyncThunk(
  "signup/signupuser",
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isMultipart: true, isAuthHeader: true, isSessionKey: true  });
    try {
      dispatch(updateLoading(true));
      const response = await API.post(SIGNUP, data);
      dispatch(updateLoading(false));
      return response;
    } catch (err) {
      return err;
    }
  }
);
const fetchSocialLogin = createAsyncThunk(
  "social/login",
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isMultipart: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.post(SOCIAL_LOGIN, data);
      dispatch(updateLoading(false));
      return response;
    } catch (err) {
      ToastNotifyError(err);
      return err;
    }
  }
);
const fetchGuestUserFlow = createAsyncThunk(
  guest_user_flow,
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(GET_GUEST_USER_FLOW);
      dispatch(updateLoading(false));
      return response.data;
    } catch (err) {
      ToastNotifyError(err);
      return err;
    }
  }
);
const fetchTermsAndCondition = createAsyncThunk(
  terms_and_condition,
  async (querry, { dispatch, getState }) => {
    const API = getAuthorization(getState);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(TERMS_AND_CONDITION + querry);
      dispatch(updateLoading(false));
      return response.data;
    } catch (err) {
      ToastNotifyError(err);
      return err;
    }
  }
);

const fetchPrivacyPolicy = createAsyncThunk(
  "privacy-policy",
  async (querry, { dispatch, getState }) => {
    const API = getAuthorization(getState);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(PRIVACY_POLICY + querry);
      dispatch(updateLoading(false));
      return response.data;
    } catch (err) {
      ToastNotifyError(err);
      return err;
    }
  }
);
const fetchForgetPassword = createAsyncThunk(
  "forget_password",
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.post(FORGET_PASSWORD, data);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);
const fetchResetPassword = createAsyncThunk(
  "reset_password",
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.post(RESET_PASSWORD, data);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);
const fetchResetLinkCheck = createAsyncThunk(
  "reset_link_check",
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.post(RESET_LINK_CHECK, data);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

export { fetchLogin, fetchLogout, fetchPostSignup, fetchSocialLogin, fetchGuestUserFlow, fetchTermsAndCondition, fetchPrivacyPolicy, fetchForgetPassword, fetchResetPassword, fetchResetLinkCheck };
